import { cn } from '@bem-react/classname';
import React, { FC } from 'react'
import { useLocation } from 'react-router-dom';
import LinkWrap from 'components/Link/_wrap'
import './BreadcrumbTeacher.scss'

interface IBreadcrumbTeacher {
  activeLink?: string
}

const BreadcrumbTeacher: FC<IBreadcrumbTeacher> = ({activeLink}) => {
  const location = useLocation();
  const cnBreadcrumbTeacher = cn('BreadcrumbTeacher');
  const listLinkBreadcrumb = [
    {href: '/test_editor', titleLink: 'Cоставление работ'},
    {href: '/teacher/test', titleLink: 'Составленные работы, архив работ'},
    {href: '/teacher/pupil', titleLink: 'Список учащихся, список групп, архив групп'},
    {href: '/teacher/journal', titleLink: 'Классный журнал'},
    {href: '/teacher/individual-profile', titleLink: 'Индивидуальный профиль знаний учащихся'},
    {href: '/own_problems', titleLink: 'Ваши задания: составление и управление'},
    {href: '/course', titleLink: 'Ваши курсы для учащихся'}
  ]
  return(
  <>
    {listLinkBreadcrumb.map((link, index) => {
      return <LinkWrap 
        className={cnBreadcrumbTeacher()}
        activeClassName={cnBreadcrumbTeacher({'Active': link.href === location.pathname})}
        href={link.href}
        key={link.href}
      >
        {link.titleLink}
      {/*<a className={cnBreadcrumbTeacher({'Active': link.href === activeLink})} href={link.href}>{link.titleLink}</a>*/}
      </LinkWrap>
    })}
  </>)
}


export default BreadcrumbTeacher